import SAPOMailConfig     from "@/SAPOMailConfig";
import HTTPResponseEntity from '@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js';
import HTTPService        from "@/js/Shared/Services/HTTP/HTTPService.js";
import MessagesFullSearch from "@/js/Mailboxes/Entities/Messages/MessagesFullSearch";
import HouseKeeperOptions from "../Entities/HouseKeeperOptions";

export {HouseKeeperHTTPService as default };

/**
* House Keeper HTTP Service
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class HouseKeeperHTTPService {
  /**
   * Filters Endpoint
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  endpoint = SAPOMailConfig.client.endpoints.settings.housekeeper;

  /**
   * Calls the server to add a job in the housekeeper
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {HouseKeeperOptions} options
   *
   * @return {Promise<HTTPResponseEntity>}
   */
  async addJob(options) {
    let date = options.criteria.filter_date_start.split('-');

    let request = {
        form: {
            'hk-before-date_day'     : date[0],
            'hk-before-date_month'   : date[1],
            'hk-before-date_year'    : date[2],
            'hk-bigger-smaller'      : 'bigger',
            'hk-date-mode'           : 'hk-before',
            'hk-folders'             : options.folder.id,
            'hk-status'              : 'all',
            'hk-interval-end_day'    : 'dd',
            'hk-interval-end_month'  : 'mm',
            'hk-interval-end_year'   : 'aaaa',
            'hk-interval-start_day'  : 'dd',
            'hk-interval-start_month': 'mm',
            'hk-interval-start_year' : 'aaaa',
        },
        'hk-action'      : options.action,
        'hk-include'     : JSON.stringify(options.messages),
        'hk-searchId'    : options.virtual_folder,
        'view'           : options.virtual_folder,
        'slice'          : '1:999999',
    };

    if (options.action === 'move') {
      request['hk-folder-dest'] = options.destination.id;
    }

    if (options.type === 'heavy') {
      request['hk-size']      = options.size;
      request['hk-with-size'] = 'hk-with-size';
    }

    return await HTTPService.post(this.endpoint + '/addjob.php', request);
  }
}